import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import EnumsContext from "../../../../context/enums-context";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { countries, findKeyByValue, regions, statusList } from "../../../../Utils/Utils";
import useApi from "../../../../Utils/BackendClient";

import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";

import commonStyle from "../../CommonStyles.module.css";
import HistoryElement from "../../../UIElements/HistoryElement";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import TextInput from "../../../UIElements/Inputs/TextInput";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";

const NewDivision = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef(null);

    const { createDivision, fetchDivisionDetails, fetchDivisionHistory, updateDivision } = useApi();

    const [tabShowed, setTabShowed] = useState(0);
    const [history, setHistory] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [totalHistoryRecords, setHistoryTotalRecords] = useState(0);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [division, setDivision] = useState(
        {
            name: "",
            is_active: "Активний",
            root_division: null,
            country: "UKRAINE",
            region: null,
            city: "",
            street: "",
            building_number: "",
            apartment_number: "",
            notes: "",
        }
    );

    const menuItems = [
        {
            label: "Загальні дані",
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            }

        },
        {
            label: "Адреса",
            icon: 'pi pi-home',
            command: () => {
                setTabShowed(1);
            }
        },
        ...(isEdit
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(2);
                        getHistory(location.state.id, historyLazyState);
                    },
                },
            ]
            : []),
    ]

    const enumTypes = useMemo(() => ["divisions"], []);

    useGetEnums(enumTypes);

    useEffect(() => {
        if (location.state !== null) {

            setIsEdit(true);
            const fetchData = async () => {

                const response = await fetchDivisionDetails(location.state.id);

                response.data.is_active = response.data.is_active ? "Активний" : "Деактивований";

                setDivision(response.data);
            }

            fetchData();
        }
    }, [location.state, ctx.divisions, fetchDivisionDetails]);

    const formik = useFormik({
        initialValues: division,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.name === null || values.name === "") {
                errors.name = "Назва точки продажу не повинна бути пустою"
            }

            if (values.country === null || values.country === undefined) {
                errors.country = "Виберіть будь ласка країну"
            }

            if (values.region === null || values.region === undefined) {
                errors.region = "Виберіть будь ласка область"
            }
            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            values.is_active = values.is_active === "Активний" ? true : false;

            if (values.root_division != null) {
                values.root_division = findKeyByValue(ctx.divisions, values.root_division);
            }

            const response = !isEdit ? await createDivision(values) : await updateDivision(location.state.id, values);

            setSubmitLoading(false);

            const successStatus = isEdit ? 200 : 201;

            if (response.status === successStatus) {
                const toastMessage = isEdit ? { severity: "success", summary: "Успіх редагування", detail: "Точку продажу " + values.name + " успішно відредаговано", life: 3000 } :
                    { severity: "success", summary: "Успіх створення", detail: "Точку продажу " + values.name + " успішно створено", life: 3000 };
                
                if(isEdit){
                    ctx.resetEnum("divisions");
                }

                navigate("/divisions", { state: { toast: toastMessage } });
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    const getHistory = async (id, state) => {

        const response = await fetchDivisionHistory(id, state);

        console.log(response);

        if (response.status === 200) {
            setHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const toolbarLeftData = () => {

        let name = "Створення нової точки продажу";

        if (isEdit) {
            name = "Редагування точки продажу " + formik.values.name;
        }

        return !isMobile ? <h3>{name}</h3> : null;
    }

    const confirmLeave = (event) => {

        if (formik.values !== division) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/divisions") }
            });

        }
        else {
            navigate("/divisions");
        }
    }

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={false} loading={submitLoading} onRetunButtonClick={() => confirmLeave()} leftContent={toolbarLeftData()} />
        <TabMenu model={menuItems} />
        <ConfirmDialog group="headless" />
        {tabShowed === 0 && <div className="grid">
            <div className="col-4">
                <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                    <FloatLabel>
                        <InputText
                            name="name"
                            value={formik.values.name}
                            onChange={(e) => { formik.setFieldValue('name', e.target.value) }}
                            className={formik.errors.name && formik.touched.name ? 'p-invalid' : ''}
                        />
                        <label>Назва точки продажу</label>
                    </FloatLabel>
                    {formik.errors.name && formik.touched.name && (<small className={commonStyle.errorSmall}>{formik.errors.name}</small>)}
                </div>
            </div>
            <div className="col-4">
                <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                    <FloatLabel>
                        <Dropdown name="is_active" value={formik.values.is_active}
                            onChange={(e) => formik.setFieldValue('is_active', e.value)}
                            options={statusList}
                            showClear />
                        <label>Статус</label>
                    </FloatLabel>
                </div>
            </div>
        </div>}
        {tabShowed === 1 && <><div className="grid">
            <div className="col-4">
                <DropdownInput
                    formik={formik}
                    paramName="country"
                    context={countries}
                    onChange={(val) => formik.setFieldValue("country", val)}
                    label={"Країна"}
                    customStyle="w-full"
                    mandatory
                />
                <TextInput formik={formik} paramName={"street"} label={"Вулиця"} customStyle="w-full" />
            </div>
            <div className="col-4">
                <DropdownInput
                    formik={formik}
                    paramName="region"
                    context={regions}
                    onChange={(val) => formik.setFieldValue("region", val)}
                    label={"Область"}
                    customStyle="w-full"
                    mandatory
                />
                <TextInput formik={formik} paramName={"building_number"} label={"Номер будинку"} customStyle="w-full" />
            </div>
            <div className="col-4">
                <TextInput formik={formik} paramName={"city"} label={"Населений пункт"} customStyle="w-full" mandatory />
                <TextInput formik={formik} paramName={"apartment_number"} label={"Квартира"} customStyle="w-full" />
            </div>
        </div>
            <div className={`p-inputgroup col-8`}>
                <span className="p-float-label md:w-90">
                    <InputTextarea value={formik.values.description} onChange={(e) => { formik.setFieldValue('description', e.target.value) }} rows={10} cols={80} />
                    <label>Примітки</label>
                </span>
            </div>
        </>}
        {tabShowed === 2 && <HistoryElement data={history} lazyState={historyLazyState} totalRecords={totalHistoryRecords} onHistoryPage={onHistoryPage} isAct={false} />}
    </form>)
}

export default NewDivision;